import * as React from "react";
import { Flex, Text, Callout } from "@radix-ui/themes";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { STRINGS } from "../../../constants/strings";
import { LoginForm } from "./LoginForm";
import { OrganizationSelector } from "./OrganizationSelector";
import type { Organization, StrapiMetadata } from "../../../types";

export interface AuthProps {
  onLogin: (email: string, password: string) => void;
  loading: boolean;
  error: string | null;
  requireOrgSelection?: boolean;
  organizations?: Organization[];
  onSelectOrganization?: (orgId: StrapiMetadata['documentId']) => void;
}

const Auth: React.FC<AuthProps> = ({
  onLogin,
  loading,
  error,
  requireOrgSelection,
  organizations = [],
  onSelectOrganization,
}) => {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      style={{ minHeight: "100vh", padding: "16px" }}
    >
      <Flex direction="column" gap="4" style={{ width: "100%", maxWidth: "320px" }}>
        <Flex direction="column" align="center" gap="2" style={{ marginBottom: "8px" }}>
          <img
            src="assets/logo-icon-text.png"
            alt="Refly Logo"
            style={{ height: "48px", width: "auto" }}
          />
          <Text size="5" weight="bold" align="center">
            {requireOrgSelection ? STRINGS.AUTH.SELECT_ORGANIZATION_TITLE : STRINGS.AUTH.TITLE}
          </Text>
        </Flex>

        {error && (
          <Callout.Root color="red" role="alert">
            <Callout.Icon>
              <InfoCircledIcon />
            </Callout.Icon>
            <Callout.Text>{error}</Callout.Text>
          </Callout.Root>
        )}

        {!requireOrgSelection ? (
          <LoginForm onLogin={onLogin} loading={loading} />
        ) : (
          <OrganizationSelector
            organizations={organizations}
            onSelectOrganization={(id) => onSelectOrganization?.(id)}
          />
        )}
      </Flex>
    </Flex>
  );
};

export default Auth;
